import type { AdminTenantMemberDto } from '../types/tenants.types';
import { getMemberStatusVariant } from '../utils/tenant-status.utils';
import type { DataTableColumn, PaginationMeta } from '@/shared/components/ui/data-table';
import { DataTable } from '@/shared/components/ui/data-table';
import { StatusBadge } from '@/shared/components/ui/status-badge';
import { formatIsoDate } from '@/shared/utils/format-date.utils';
import { getRoleLabel } from '@/shared/utils/role-label.utils';

interface TenantMembersTableProps {
  data: AdminTenantMemberDto[];
  pagination?: PaginationMeta;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  emptyMessage?: string;
}

export function TenantMembersTable({
  data,
  pagination,
  onPageChange,
  onPageSizeChange,
  emptyMessage,
}: TenantMembersTableProps) {
  const columns: DataTableColumn<AdminTenantMemberDto>[] = [
    {
      key: 'displayName',
      header: 'Miembro',
      render: (row) => (
        <div className="flex flex-col gap-0.5">
          <span className="text-light text-sm font-medium">{row.displayName ?? '—'}</span>
          <span className="text-primary text-xs opacity-60">{row.email}</span>
        </div>
      ),
    },
    {
      key: 'role',
      header: 'Rol',
      render: (row) => <span className="text-primary text-sm">{getRoleLabel(row.role)}</span>,
    },
    {
      key: 'isActive',
      header: 'Estado',
      render: (row) => (
        <StatusBadge
          status={getMemberStatusVariant(row.isActive)}
          label={row.isActive ? 'Activo' : 'Inactivo'}
        />
      ),
    },
    {
      key: 'joinedAt',
      header: 'Miembro desde',
      render: (row) => <span className="text-primary text-sm">{formatIsoDate(row.joinedAt)}</span>,
    },
  ];

  return (
    <DataTable
      title="Miembros"
      subtitle={String(pagination?.totalCount ?? data.length)}
      rows={data}
      columns={columns}
      getRowKey={(row) => row.membershipId}
      pagination={pagination}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      emptyMessage={emptyMessage}
    />
  );
}
